import React, { useEffect, useState } from "react";
import { config } from "../config/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

const MateriaList = ({ onEdit, onDelete, reloadTrigger }) => {
    const [materias, setMaterias] = useState([]);

    const fetchMaterias = () => {
        fetch(`${config.apiUrl}/materias`)
            .then((res) => res.json())
            .then(setMaterias)
            .catch(console.error);
    };

    useEffect(() => {
        fetchMaterias(); // Cargar materias al inicio y cada vez que cambie reloadTrigger
    }, [reloadTrigger]);

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Lista de Materias</h2>
            <table className="table table-bordered table-striped table-dark">
                <thead className="thead-dark">
                <tr>
                    <th>Nombre de la Materia</th>
                    <th>Grado</th>
                    <th colSpan={2} className="text-center">Acciones</th>
                </tr>
                </thead>
                <tbody>
                {materias.map((materia) => (
                    <tr key={materia.materia_id}>
                        <td>{materia.nombre_materia}</td>
                        <td>{materia.nombre_grado}</td>
                        <td className="text-center">
                            <button
                                className="btn btn-warning btn-sm mr-2"
                                onClick={() => onEdit(materia)}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                            </button>
                        </td>
                        <td className="text-center">
                            <button
                                className="btn btn-danger btn-sm"
                                onClick={() => onDelete(materia.materia_id)}
                            >
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default MateriaList;